import React from "react";
import { FilterContainer } from "./style";
export default function FilterComponent({ filterText, onFilter }) {
  return (
    <FilterContainer>
      <input
        id="search"
        type="text"
        placeholder="Buscar produto"
        value={filterText}
        onChange={onFilter}
      />
    </FilterContainer>
  );
}
